import { render, staticRenderFns } from "./More_ArchiveDownload.vue?vue&type=template&id=64aa673a&scoped=true&"
import script from "./More_ArchiveDownload.vue?vue&type=script&lang=js&"
export * from "./More_ArchiveDownload.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./More_ArchiveDownload.vue?vue&type=style&index=1&id=64aa673a&prod&scoped=true&lang=css&"
import style2 from "./More_ArchiveDownload.vue?vue&type=style&index=2&id=64aa673a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64aa673a",
  null
  
)

export default component.exports